
(function () {
  'use strict';

  const CARD = '.candyrack-slider-cart-offer-item-wrapper';
  const TITLE = '.candyrack-slider-cart-offer-item-header';
  const PRICE_WRAPPER = '.candyrack-slider-cart-offer-price-wrapper';
  const MESSAGE = 'ms7-candyrack-promo-message';

  
function getDiscount() {
  const cartItems = document.querySelector(
    '#CartDrawer-CartItems'
  );

  if (!cartItems) return 0;

  const discount = Number(
    cartItems.getAttribute('data-ms7-tyre-discount')
  );

  return [10, 20, 25, 30].includes(discount)
    ? discount
    : 0;
}


  function updateMessages() {
    const discount = getDiscount();

    document.querySelectorAll(CARD).forEach(function (card) {
      const title = card.querySelector(TITLE);
      const priceWrapper = card.querySelector(PRICE_WRAPPER);

      let message = card.querySelector('.' + MESSAGE);

      const productLink = card.querySelector(
        '.candyrack-slider-cart-offer-item-image-container a'
      );

      const productUrl = productLink
        ? productLink.getAttribute('href') || ''
        : '';

      const productTitle = title
        ? title.textContent || ''
        : '';

      const isTyre = /tyre|tire/i.test(
        productTitle + ' ' + productUrl
      );

      if (!isTyre || !priceWrapper || !discount) {
        if (message) message.remove();
        return;
      }

      if (!message) {
        message = document.createElement('div');
        message.className = MESSAGE;
      }

      if (message.previousElementSibling !== priceWrapper) {
        priceWrapper.insertAdjacentElement('afterend', message);
      }

      const messageKey = String(discount);

      if (message.dataset.discount !== messageKey) {
        message.replaceChildren();

        const saving = document.createElement('div');
        saving.className = 'ms7-candyrack-saving';

        const savingLabel = document.createElement('span');
        savingLabel.textContent = 'Add this tyre and ';

        const savingValue = document.createElement('span');
        savingValue.className = 'ms7-candyrack-saving-value';
        savingValue.textContent = 'save ' + discount + '%!';

        saving.append(savingLabel, savingValue);

        const fitting = document.createElement('div');
        fitting.className = 'ms7-candyrack-fitting';
        fitting.textContent =
          'Tyre/s will come fitted at no extra cost';

        message.append(saving, fitting);
        message.dataset.discount = messageKey;
      }
    });
  }

  let scheduled = false;

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      updateMessages();
    });
  }

  function init() {
    updateMessages();

    const observer = new MutationObserver(scheduleUpdate);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['data-ms7-tyre-discount']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }
})();
